module.exports = __webpack_public_path__ + "img/bg-title.8a2f1d34.png";